export function initTextInput() {
  // Static placeholder fields do not require JS state.
}
